export type CmsPagesType = {
  [pageId in string]: {
    [elementId in string]: {
      pageId: pageId;
      elementId: elementId;
      default: string | number;
    };
  };
};

export type ElementConfig = CmsPagesType[keyof CmsPagesType][keyof CmsPagesType[keyof CmsPagesType]];

const CMS_UNIQUE_KEY = "InnerMatrix";

const RawConfig: any = {
  Home: {
    Heading: "Discover Yourself",
    SubHeading: "A better life is waiting.",
    FindInnerMatrixButton: "Find Your Inner Matrix Intro"
  },
  WhatIs: {
    Heading1: "What is",
    Heading2: "The Inner Matrix?",
    SubHeading:
      "The Inner Matrix is what lives inside our mind, emotions, body, and spirit that creates the matrix of our inner experience.",
    ExploreCTA: "Explore the Book"
  },
  HowItWorksModule: {
    Heading: "Here's how it works.",
    SubHeading1A: "<span>1. </span>Meet once a week.",
    SubHeading1B: "(for 5 weeks)",
    Content1:
      "Trainers create a supportive space where you will meet and can focus on transcending mental, emotional and physical patterns that are limiting your success.",
    SubHeading2A: "<span>2. </span>Connect &amp; Share",
    SubHeading2B: "(roundtable discussion)",
    Content2:
      "Join in an environment where it is possible to share on a deep level and form meaningful connections with each other.",
    SubHeading3: "<span>3. </span>Inner-training Practice",
    Content3:
      "Each week there is a reading assignment, video lesson, daily meditation, and check-in practice to support your inner development.",
    SubHeading4: "<span>4. </span>It's just the beginning",
    Content4:
      "Explore what you can do once The Inner Matrix Intro is complete. Inner Matrix Systems offers weekend intensive programs that provide tools to support you in creating new ways of being, allowing you to step into fulfilling experiences and a new vision for life."
  },
  FindAGroup: {
    Heading: "Find a Intro",
    Content:
      "Inner Matrix Intros take place around the world. Enter your state or country name to locate a intro in your area, or you can join a Virtual Intro that meets online and includes interactive discussions."
  },
  HostAGroupComponent: {
    Heading1: "Would you like to",
    Heading2: "Host a Intro?",
    Content:
      "We provide the facilitator to manage the sign up process for your guests and lead the discussions. You share your home, office or studio and invite your friends and family.",
    HostCTA: "Become a host."
  },
  SuccessStories: {
    Heading: "Success Stories",
    Story1: "I have found more success and fulfillment in my life than I ever thought possible.",
    Teller1: "- Patrice S.",
    Story2: "I feel a sense of vitality and freedom in my body beyond what I have ever known before.",
    Teller2: "- Laina E.",
    Story3: "I have learned how to treat myself kindly, creating a quality of life I never thought possible.",
    Teller3: "- Glenn G.",
    Story4: "I now see myself as a creator of everything in my life and therefore put intention into each day.",
    Teller4: "- Ann E."
  },
  WhoIsJoey: {
    Heading: "<strong>Who is</strong><br />Joey Klein?",
    SubHeading: "Learn about Joey's workshops.",
    Content1:
      "Joey Klein teaches people to consciously transform their lives using the practices he developed during years of study with gifted teachers, neuroscientists, psychologists and doctors from around the world. His practical approach marries the wisdom traditions of East and West with the latest scientific studies in genetics and psychology, grounding them for the modern world.",
    Content2:
      "Joey has been teaching internationally for 18 years, leading classes and retreats that focus on changing core mental, emotional and physical patterns to enhance daily life and create deeper meaning. He has worked with tens of thousands of people, including C-level executives at Fortune 100 companies, professional athletes and other professionals to create measurable shifts in their careers and lives. Joey’s writings, teachings and interviews are published in 14 countries."
  },
  BiggerPicture: {
    Heading: "The Bigger Picture",
    SubHeading:
      "Reading The Inner Matrix is just the beginning. There is an entire system designed to help you experience a meaningful and fulfilling life. Inner Matrix Systems offers many options to support you in creating new ways of being. Take a look at what we have to offer below.",
    LearnMoreCTA1: "Learn more.",
    LearnMoreCTA2: "Learn more.",
    LearnMoreCTA3: "Learn more.",
    LearnMoreCTA4: "Learn more.",
    Picture1Title: "Join an IMG",
    Picture1Desc:
      "Transform your life with an&nbsp;<i>Inner Matrix Intro.&nbsp;</i>In today’s fast-paced and stressful world, focusing the mind and empowering the emotions are essential to living a fulfilling, peaceful life. Leverage the tools in The Inner Matrix in a small intro environment.",
    Picture2Title: "One on One Training",
    Picture2Desc:
      "Work one-on-one with a certified Inner Matrix Systems Trainer to catalyze personal and professional development. All trainers have completed a 2,000 plus hour certification program with Joey Klein.",
    Picture3Title: "Trainer-Led Series",
    Picture3Desc:
      "Inner Matrix Systems Trainers teach a four-part series designed to consistently accelerate your growth. The trainer-led series includes teachings, meditations and daily action plans.",
    Picture4Title: "Power Series Weekend Event",
    Picture4Desc:
      "The Power Series is a year-long foundational program which consists of quarterly weekend intensives, providing an ongoing process of personal development grounded in understanding and shifting deep patterns."
  },
  FreeChapter: {
    Heading: "Preview The Inner Matrix",
    SubHeading:
      "Enter your name and email below and we'll send you the first chapter of&nbsp;<i>The Inner Matrix</i>&nbsp;plus an inner-training practice, for free!",
    FreeChapterCTA: "Get Your Free Chapter"
  },
  HowItWorks: {
    Heading1: "What to Expect",
    SubHeading1: "A better life is waiting.",
    FindAGroupCTA: "Find a intro",
    Heading2: "What is Inner Matrix Systems?",
    SubHeading2:
      "Inner Matrix Systems is a simple and practical approach that propels us toward a new experience of life. Watch the video to see how it works.",
    LearnMoreCTA: "Learn more."
  },
  GroupsIndex: {
    Heading: "Find an Introduction to Inner Matrix Systems Near You.",
    SubHeading: "Your journey starts here.",
    FindAGroupCTA: "Find a intro",
    VirtualGroupsHeading: "Explore our virtual intros."
  },
  HostAGroupView: {
    Heading: "Host a Intro",
    SubHeading: "Hosting a Intro is Easy!",
    AllYouNeedTo: "As a host, all you need is to",
    AllYouNeedTo1: "Provide the space",
    AllYouNeedTo2: "Invite 5 or more participants",
    AllYouNeedTo3: "Attend all 6 sessions with the invited participants"
  },
  About: {
    Heading1: "About",
    Heading2: "The Inner Matrix",
    SubHeading1A: "About",
    SubHeading1B: "The Author",
    BuyBookCTA: "Buy Joey's book",
    Content1A:
      "Joey Klein teaches people to consciously transform their lives using techniques he developed fusing cutting-edge neuroscience with ancient practices from the world's wisdom traditions.",
    Content1B:
      "Through Inner Matrix Systems, the organization he founded many years ago, Klein leads transformational workshops around the country and supports a growing global community of people committed to strengthening their minds, emotions and bodies, and deepening their connection to spirit.",
    SubHeading2: "What is Inner Matrix Systems?",
    Content2A:
      "Inner Matrix Systems, founded by Joey Klein, is the ongoing process of personal and professional development grounded in understanding and shifting the deep mental, emotional and physical patterns that keep us from reaching our true potential. the simple and practical approach propels us toward a new experience of life.",
    Content2B:
      "Joey's core teachings are shared through the one-year Transformation Series, which includes weekend intensives on Power of Focus, Power of Emotion, Power of Vision and Power of Intuition. Certified Conscious Transformation Trainers in established and emerging communities around the world provide the support to sustain your learning and deepen your practice."
  },
  AboutBook: {
    Heading1: "Introduction to Inner Matrix Systems",
    Heading2: "A better life is waiting",
    RatingsReviewsLabel: "Ratings & Reviews",
    SubHeading1: "How Do Inner Matrix Intros Work?"
  },
  AboutBookBlurb: {
    Heading1: "About",
    Heading2: "<strong>The Book</strong>",
    BuyBookCTA: "Buy Joey's book",
    Content1:
      "The Inner Matrix illuminates a proven approach to living a truly rich and meaningful life – one more deeply connected to spirit. Marrying the ancient wisdom traditions of East and West with the latest science in genetics, psychology, and brain function, Klein provides a cutting-edge system to transform your life by shifting deep mental, emotional, and physical patterns that create stress and limit your success.",
    Content2:
      "Those engaging Klein’s Inner Matrix Systems™ practices routinely experience: <strong>Reduced stress, Increased focus, Higher emotional intelligence, Improved health and well-being, Enhanced connection to spirit.</strong>"
  },
  AboutBookRatingsReview: {
    Review1: '"A must read for anyone looking to make positive change in their lives."'
  },
  BookItems: {
    FindAGroupCTA: "Find a intro",
    Item1Name: "1. Meet once a week.",
    Item1SubHeading: "(for 5 weeks)",
    Item1Blurb:
      "Trainers create a supportive space where you will meet and can focus on transcending mental, emotional and physical patterns that are limiting your success.",
    Item2Name: "2. Connect & Share",
    Item2SubHeading: "(roundtable discussion)",
    Item2Blurb:
      "Join in an environment where it is possible to share on a deep level and form meaningful connections with each other.",
    Item3Name: "3. Inner-training Practice",
    Item3SubHeading: "",
    Item3Blurb:
      "Each week there is a reading assignment, video lesson, daily meditation, and check-in practice to support your inner development.",
    Item4Name: "4. It's just the beginning",
    Item4SubHeading: "",
    Item4Blurb:
      "Explore what you can do once The Inner Matrix Intro is complete. Conscious Transformation offers weekend intensive programs that provide tools to support you in creating new  ways of being, allowing you to step into fulfilling experiences and a new vision for life."
  },
  Contact: {
    AllOtherInquiries:
      " For all other inquiries, please use the form below and we will respond within 24 hours. We look forward to connecting with you soon!"
  },
  MyGroups: {
    Heading1: "Your Intro to IMS Course.",
    Heading2: "3 Life Changing Sessions"
  }
};

const _cmsPages: any = {};

for (const rawPage in RawConfig) {
  const page = `${CMS_UNIQUE_KEY}_${rawPage}`;
  _cmsPages[page] = {};

  for (const element in RawConfig[rawPage]) {
    _cmsPages[page][element] = {
      pageId: page,
      elementId: element,
      default: RawConfig[rawPage][element]
    };
  }
}

export const CmsPages: CmsPagesType = _cmsPages;
